import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'tn-components-library';
import './styles.css';
import CustomNoData from "./index"

export default class NoData extends Component {
    render() {
        let intl = this.context.intl;
        return (
            <div className="margin-top-40 text-center">
                <Typography category='heading3' className="no-margin" value={intl.formatMessage({ id: "no_data_1" })} />
                <Typography category='heading3' className="no-margin" value={intl.formatMessage({ id: "no_data_2" })} />
                <CustomNoData/>
            </div>
        );
    }
}

NoData.contextTypes = {
    intl: PropTypes.object.isRequired
}

NoData.defaultProps = {
    queryNoMatch: false
}